import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';



export const BrandDetail = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number],
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH']),
        brandDetail(){
            let arReturn = {};
            for(let i in this.struct[this.structKey].CHILDS){
                if(this.struct[this.structKey].CHILDS[i].componentData.VUE_COMPONENT == 'BrandDetail'){
                    arReturn = this.struct[this.structKey].CHILDS[i].componentData.ITEM;
                }
            }
            return arReturn;
        }
    },
    template: `
    <section v-if="Object.keys(this.brandDetail).length" class="section section--gray section--bg lazy-bg">
        <div class="container">
            <div class="brand__detail">
                <div class="brand__detail-top">
                    <div class="brand__detail-logo" :class="{'no-photo': this.brandDetail.BRAND.IMAGE === false}">
                        <img :src="(this.brandDetail.BRAND.IMAGE !== false ? this.brandDetail.BRAND.IMAGE : this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg')" :alt="this.brandDetail.NAME" :title="this.brandDetail.NAME" loading="lazy">
                    </div>
                    <div class="brand__detail-desc content" v-html="this.brandDetail.TEXT">
                    </div>
                    <div v-if="this.brandDetail.BRAND.COUNTRY || this.brandDetail.BRAND.FLAG" class="brand__detail-country">
                        <img v-if="this.brandDetail.BRAND.FLAG" :src="this.brandDetail.BRAND.FLAG" alt="" title="" loading="lazy">
                        <template v-if="this.brandDetail.BRAND.COUNTRY">
                            {{this.brandDetail.BRAND.COUNTRY}}
                        </template>
                    </div>
                </div>
                <div v-if="this.brandDetail.BACK_BTN" class="section__back">
                    <a :href="this.brandDetail.BACK_BTN" class="btn btn--border">
                        <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                        К брендам
                    </a>
                </div>
            </div>
        </div>
    </section>
    `
}